// Where a shape's bottom edge starts: the leftmost point among those sitting
// on its lowest y, as a fraction (0–1) of the viewBox width from its left
// edge. A caption placed there lines up with the foot of the shape rather than
// with the box around it — which for a shape with a notch or a step at the
// bottom left is not the same place.
//
// Hand-traced outlines wobble by a fraction of a unit along what is meant to
// be one straight edge, so "lowest" allows a small band rather than an exact
// match; at any on-screen size the band is well under a pixel.
const BOTTOM_TOLERANCE = 0.005

export const parseSvgBottomLeft = (svgContent: string): number | undefined => {
  const viewBox = parseSvgViewBox(svgContent)
  if (!viewBox) return undefined

  const points = parseSvgShapePoints(svgContent)
  if (!points.length) return undefined

  const bottom = Math.max(...points.map(p => p.y))
  const band = viewBox.height * BOTTOM_TOLERANCE
  const left = Math.min(...points.filter(p => bottom - p.y <= band).map(p => p.x))

  return Math.min(Math.max((left - viewBox.x) / viewBox.width, 0), 1)
}
